export default "__VITE_ASSET__4293c70d__"